// Auto generated file, do not manually modify!
// com.hotpads.customeranalytics.client.enterpriseanalytics.dto.CustomerAnalyticsAdspendCategory

export enum CustomerAnalyticsAdspendCategory {
  BASE = 'BASE',
  BOOST = 'BOOST',
  DAILY_FEED_CONNECT = 'DAILY_FEED_CONNECT',
  ENHANCED = 'ENHANCED',
  FLAT_FEE_FEED_CONNECT = 'FLAT_FEE_FEED_CONNECT',
  INTEGRATED_PAY_PER_LEASE = 'INTEGRATED_PAY_PER_LEASE',
  LEASE_UP = 'LEASE_UP',
  LEGACY_PAY_PER_LEASE = 'LEGACY_PAY_PER_LEASE',
  LISTING_SPOTLIGHT = 'LISTING_SPOTLIGHT',
  MEDIA_ADD_ON = 'MEDIA_ADD_ON',
  MFH_FLAT_FEE = 'MFH_FLAT_FEE',
  PAY_PER_CLICK = 'PAY_PER_CLICK',
  PAY_PER_LEAD = 'PAY_PER_LEAD',
  PREMIUM = 'PREMIUM',
  PREMIUM_PLUS = 'PREMIUM_PLUS',
  SFH_FLAT_FEE_LEGACY = 'SFH_FLAT_FEE_LEGACY',
  SFH_LEGACY = 'SFH_LEGACY',
  SIGNATURE = 'SIGNATURE',
  WAITLIST = 'WAITLIST',
}

export const CustomerAnalyticsAdspendCategory_values = [
  CustomerAnalyticsAdspendCategory.BASE,
  CustomerAnalyticsAdspendCategory.BOOST,
  CustomerAnalyticsAdspendCategory.DAILY_FEED_CONNECT,
  CustomerAnalyticsAdspendCategory.ENHANCED,
  CustomerAnalyticsAdspendCategory.FLAT_FEE_FEED_CONNECT,
  CustomerAnalyticsAdspendCategory.INTEGRATED_PAY_PER_LEASE,
  CustomerAnalyticsAdspendCategory.LEASE_UP,
  CustomerAnalyticsAdspendCategory.LEGACY_PAY_PER_LEASE,
  CustomerAnalyticsAdspendCategory.LISTING_SPOTLIGHT,
  CustomerAnalyticsAdspendCategory.MEDIA_ADD_ON,
  CustomerAnalyticsAdspendCategory.MFH_FLAT_FEE,
  CustomerAnalyticsAdspendCategory.PAY_PER_CLICK,
  CustomerAnalyticsAdspendCategory.PAY_PER_LEAD,
  CustomerAnalyticsAdspendCategory.PREMIUM,
  CustomerAnalyticsAdspendCategory.PREMIUM_PLUS,
  CustomerAnalyticsAdspendCategory.SFH_FLAT_FEE_LEGACY,
  CustomerAnalyticsAdspendCategory.SFH_LEGACY,
  CustomerAnalyticsAdspendCategory.SIGNATURE,
  CustomerAnalyticsAdspendCategory.WAITLIST,
] as const;
